import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { BreadcrumbPlugin, CarouselPlugin, LayoutPlugin } from 'bootstrap-vue'
import VueMeta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import VueLazyLoad from 'vue-lazyload'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles/app.scss'

Vue.component('pulse-loader', () => import('vue-spinner/src/PulseLoader.vue'))
Vue.use(BreadcrumbPlugin)
Vue.use(CarouselPlugin)
Vue.use(LayoutPlugin)
Vue.use(VueMeta)
Vue.use(VueLazyLoad)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 100,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
